<template>
  <div class="order-detail">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">订单详情</div>
      <i class="iconfont"></i>
    </div>
    <!-- 已发货 -->
    <div v-if="orderInfo.status == '已发货'">
      <div class="order-status">
        <div class="status-left">
          <i class="iconfont">&#xe601;</i>
          <div>
            <div class="status-title">已发货</div>
            <div class="status-txt">您的商品已发出，请注意查询物流信息</div>
          </div>
        </div>
        <!-- <div class="logistics-btn" @click="showModal=true">查看物流</div> -->
      </div>
    </div>
    <!-- 代付款 -->
    <div v-else-if="orderInfo.status == '待付款'">
      <div class="order-status">
        <div class="status-left">
          <i class="iconfont">&#xe601;</i>
          <div>
            <div class="status-title">待付款</div>
            <div class="status-txt">
              剩
              <span>{{ orderCountdown.m }}分{{ orderCountdown.s }}秒</span>
              自动关闭订单，请尽快支付
            </div>
          </div>
        </div>
        <div class="pay-btn">
          <div class="logistics-btn" @click="toPay">立即支付</div>
          <!-- <div class="cancel-btn" @click="toCancel">取消订单</div> -->
        </div>
      </div>
    </div>
    <!-- 其他状态 -->
    <div v-else>
      <div class="order-status">
        <div class="status-left">
          <i class="iconfont">&#xe601;</i>
          <div>
            <div class="status-title">{{ orderInfo.status }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单信息 -->
    <div class="order-item">
      <div class="order-title">订单信息</div>
      <div class="txt">订单编号：{{ orderInfo.id || $route.query.id }}</div>
      <div class="txt">下单时间： {{ orderInfo.time }}</div>
      <div class="txt">支付方式：{{ orderInfo.payWay }}</div>
    </div>
    <!-- 配送信息 -->
    <div class="order-item" v-if="orderInfo.address">
      <div class="order-title">配送信息</div>
      <div class="txt">收货人：{{ orderInfo.address[0].username }}</div>
      <div class="txt">手机：{{ orderInfo.address[0].mobile }}</div>
      <div class="txt">
        地址：{{ orderInfo.address[0].province }}
        {{ orderInfo.address[0].city }} {{ orderInfo.address[0].county }}
        {{ orderInfo.address[0].detail }}
      </div>
      <div class="txt" v-if="orderInfo.address[0].postcode">
        邮编：{{ orderInfo.address[0].postcode }}
      </div>
    </div>
    <!-- 发票信息 -->
    <div class="order-item" v-if="orderInfo.invoice">
      <div class="order-title">发票信息</div>
      <div class="txt">
        发票抬头：{{ ["", "个人", "企业"][orderInfo.invoice.title] }}
      </div>
      <div class="txt">抬头名称：{{ orderInfo.invoice.name }}</div>
      <div class="txt">纳税人识别号：{{ orderInfo.invoice.code }}</div>
      <div class="txt">发票内容：商品明细</div>
      <div class="txt" v-if="orderInfo.invoice.file">
        电子发票：<a target="_blank" :download="orderInfo.id || $route.query.id" :href="orderInfo.invoice.file">下载</a>
      </div>
    </div>
    <!-- 退款信息 -->
    <div class="order-item" v-if="orderInfo.refundInfo && orderInfo.refundInfo.status != 0">
      <div class="order-title">退款信息</div>
      <template v-if="orderInfo.refundInfo.status == 2">
        <div class="txt">
          物流公司：{{ orderInfo.refundInfo.company | namify }}
        </div>
        <div class="txt">物流单号：{{ orderInfo.refundInfo.sid }}</div>
      </template>
      <template v-else>
        <el-form :model="refundInfoForm" :rules="refundInfoRules" ref="refundInfoForm">
          <el-form-item prop="company" label="物流公司：" label-width="100px">
            <!-- <el-input v-model.trim="refundInfoForm.company" autocomplete="off" placeholder="请填写物流公司"></el-input> -->
            <el-select v-model="refundInfoForm.company" placeholder="请选择物流公司">
              <el-option v-for="(item, idx) in kdOptions" :key="`KD_${idx}`" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="sid" label="物流单号：" label-width="100px">
            <el-input v-model.trim="refundInfoForm.sid" autocomplete="off" placeholder="请填写物流单号"></el-input>
          </el-form-item>
        </el-form>
        <el-button class="save-refund" @click="saveRefund">确 定</el-button>
      </template>
    </div>
    <!-- 配送清单 -->
    <div class="order-list">
      <div class="order-title">配送清单</div>
      <div class="order-content">
        <div class="content-title">商品</div>
        <div class="content">
          <div class="goods-items" v-for="(item, index) in orderInfo.goods" :key="index">
            <div class="goods-items-content">
              <div class="item-img">
                <div @click="goDetail(item)">
                  <img :src="item.cover + '?$thumb$'" alt class="goods-pic" />
                </div>
              </div>
              <div class="goods-right">
                <div class="goods-info">
                  <div @click="goDetail(item)" class="goods-name">{{ item.name }}</div>
                  <div class="goods-size">
                    <div style="margin-right: 30px">
                      颜色：{{ item.color.name }}
                    </div>
                    <div>尺码：{{ item.size }}</div>
                  </div>
                  <p class="markdown-tip is-desktop" v-if="item.is_mark_down"><span
                      class="iconfont-ot-website">&#xe60f;</span><span>折扣商品不可与其他活动同时享受折扣</span></p>
                </div>
                <div class="goods-others">
                  <div class="num">x{{ item.quantity }}</div>
                  <div class="price">
                    <p class="item-original_price" v-if="isShowOriginalPrice(item)">
                      <span class="rmb-symbol">￥</span>{{ (item.original_price || 0) | filterPrice }}
                    </p>
                    <p>
                      <span class="rmb-symbol">￥</span>{{ item.price }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <p class="markdown-tip is-mobile" v-if="item.is_mark_down"><span
                class="iconfont-ot-website">&#xe60f;</span><span>折扣商品不可与其他活动同时享受折扣</span></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单摘要 -->
    <div class="order-others">
      <div class="total">
        <div class="tit">商品总额</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ (orderInfo.subTotal || 0) | filterPrice }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">优惠金额</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ (orderInfo.discount_amount || 0) | filterPrice }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">积分抵扣</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ (orderInfo.pointsDeductedAmount || 0) | filterPrice }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">运费</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ (orderInfo.shipping || 0) | filterPrice }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">总计</div>
        <div class="num">
          <span class="rmb-symbol" style="color: #000">￥</span>
          <span style="color: #000">{{ (orderInfo.amount || 0) | filterPrice }}</span>
        </div>
      </div>
    </div>
    <div class="logistics-bottom" v-if="orderInfo.status == '待付款'">
      <div class="logistics-btn" @click="toPay">立即支付</div>
      <!-- <div class="cancel-btn" @click="toCancel">取消订单</div> -->
    </div>
    <!-- 支付扫码弹窗 -->
    <div class="dialog wait-pay" v-if="payStatus == 'wait'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideWaitPayDialog">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="pay-method">
            <template v-if="paymentMethod == 1 || paymentMethod == 3">
              <i class="iconfont ali-pay">&#xe600;</i>
            </template>
            <template v-else>
              <i class="iconfont wx-pay">&#xe62b;</i>
            </template>
            <span class="pay-name">{{
              ["", "支付宝", "微信支付", "支付宝", "微信支付", "微信支付"][
              paymentMethod
              ]
            }}</span>
          </div>
          <div class="pay-amount">
            支付金额：
            <span class="pay-value">
              <span class="rmb-symbol">￥</span> {{ orderInfo.amount }}
            </span>
          </div>
          <div class="pay-hits">
            <div class="pay-countdown">
              距离二维码过期还剩<span class="countdown">{{ countdown.m }}分{{ countdown.s }}秒</span>
            </div>
            <div class="pay-msg">过期后请点击刷新重新获取二维码</div>
          </div>
          <div class="pay-code">
            <img :src="payCode" />
            <div v-if="codeMask" class="code-mask" @click="refreshPayCode">
              <span>已失效</span>
            </div>
          </div>
          <div class="pay-method-tips">
            <div class="text">
              打开{{
                ["", "支付宝", "微信", "支付宝", "微信", "微信"][paymentMethod]
              }}扫一扫
            </div>
            <div class="text">扫描上方二维码完成付款</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付结果弹窗 -->
    <div class="dialog pay-unknown" v-if="payStatus == 'unknown'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="closePayUnknown">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="dialog-subtitle">支付结果</div>
          <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
          <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
          <div class="btn-group">
            <button class="btn" @click="closePayUnknown">已完成支付</button>
            <button class="btn" @click="toPay">支付遇到问题，重新支付</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 物流弹框 -->
    <div class="modal" v-if="showModal">
      <div class="logistics">
        <i class="iconfont" @click="showModal = false">&#xe612;</i>
        <div class="title">物流追踪</div>
        <div class="txt">物流公司：<span></span></div>
        <div class="txt">快递单号：<span></span></div>
        <div class="detail">
          <div class="row" v-for="(item, index) in orderInfo.logisticsInfo.items" :key="index">
            <div class="time">{{ item.time }}</div>
            <div :class="[index == 0 ? 'current' : '', 'desc']">
              {{ item.message }}
            </div>
          </div>
        </div>
        <button class="sure-btn" @click="showModal = false">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import { captureManualError } from '@/sentry/index'
export default {
  data() {
    return {
      orderInfo: {},
      waitPayTimer: null,
      orderCountdown: { m: 0, s: 0 },
      showModal: false,
      //
      paymentMethod: "",
      payCode: "",
      oderPayTimer: null,
      countdown: { m: 0, s: 0 },
      codeMask: false,
      payStatus: "",
      wsInstance: null,
      //
      formLabelWidth: "25%",
      //
      kdOptions: [
        { label: "顺丰快递", value: "SF" },
        { label: "京东快递", value: "JD" },
        { label: "邮政EMS", value: "EMS" },
        { label: "申通快递", value: "STO" },
        { label: "圆通速递", value: "YTO" },
        { label: "中通速递", value: "ZTO" },
        { label: "汇通快运", value: "HTKY" },
        { label: "韵达快递", value: "YUNDA" },
        { label: "德邦快递", value: "DBL" },
        { label: "联邦快递", value: "fedex" },
        { label: "天天快递", value: "TTKDEX" },
        { label: "百世快递", value: "BAISHI" },
        { label: "CCES快递", value: "CCES" },
        { label: "宅急送", value: "ZJS" },
        { label: "E邮宝", value: "OTHER" },
        { label: "品骏物流", value: "PINJUN" },
        { label: "跨越速运", value: "KYE" },
        { label: "韵达JITX", value: "yunda_jitx" },
        { label: "中通JITX", value: "zto_jitx" },
        { label: "其他快递", value: "QTKD" },
      ],
      refundInfoForm: {
        company: "",
        sid: "",
      },
      refundInfoRules: {
        company: [
          { required: true, message: "请选择物流公司", trigger: "blur" },
        ],
        sid: [{ required: true, message: "请填写物流单号", trigger: "blur" }],
      },
      orderStatusTimer: null
    };
  },
  created() {
    if (this.$route.query.id) {
      this.getOrderDetail();
    } else {
      this.$router.replace({ path: "/myaccount/orders" });
    }
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    getOrderDetail() {
      api[types.ORDER_DETAIL]({ id: this.$route.query.id })
        .then((res) => {
          if (res?.code == 1) {
            let orderInfo = res.data;
            if (orderInfo.status == "待付款") {
              let timesAgo =
                Date.now() -
                new Date(orderInfo.time.replace(/-/g, "/")).getTime();
              // 待支付订单有效支付时间为15分钟
              if (timesAgo >= 15 * 60 * 1000) {
                console.info("待支付订单已超时");
              } else {
                let ret = Math.floor((15 * 60 * 1000 - timesAgo) / 1000);
                this.waitPayTimer = this.startCountdown(ret, (times, timer) => {
                  if (times > 0) {
                    this.orderCountdown = {
                      m: Math.floor(times / 60),
                      s: times % 60,
                    };
                  } else {
                    timer && clearInterval(timer);
                    if (this.oderPayTimer) {
                      this.$message({ message: "订单支付超时已自动关闭" });
                      this.hideWaitPayDialog();
                      this.getOrderDetail();
                    }
                    this.orderCountdown = { m: 0, s: 0 };
                    this.orderInfo.status = ""; // 修改订单状态
                  }
                });
              }
            }
            this.orderInfo = orderInfo;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err)
        });
    },
    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function")
        return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 继续支付：处理支付方式（沿用上次支付方式）
    toPay() {
      if (utils.isWXBrowser()) {
        this.paymentMethod = 5;
      } else if (utils.isMobile()) {
        this.paymentMethod = this.orderInfo.payWay == "支付宝" ? 3 : 4;
      } else {
        this.paymentMethod = this.orderInfo.payWay == "支付宝" ? 1 : 2;
      }
      this.orderPay();
    },
    // 订单支付
    orderPay() {
      api[types.ORDER_PAY]({
        orderId: this.orderInfo.id || this.$route.query.id,
        paymentMethod: this.paymentMethod,
      })
        .then((res) => {
          if (res?.code == 1) {
            if (this.paymentMethod == 1 || this.paymentMethod == 2) {
              this.payCode = res.data.url;
              this.codeMask = false;
              // 4分钟倒计时
              this.wsInstance = null;
              let oderPayTimer = this.startCountdown(res.data.expire, (times, timer) => {
                if (times > 0) {
                  this.countdown = { m: Math.floor(times / 60), s: times % 60 };
                } else {
                  timer && clearInterval(timer);
                  this.countdown = { m: 0, s: 0 };
                  this.codeMask = true;
                  this.wsInstance?.close();
                }
              });
              this.oderPayTimer = oderPayTimer;
              // 查询支付状态
              this.checkOrderStatus(res.data?.id)
              // this.wsInstance = api[types.QUERY_ORDER_PAY_STATUS](
              //   res.data.id,
              //   (evt, ws) => {
              //     if (evt?.data) {
              //       try {
              //         let res = JSON.parse(evt.data);
              //         if (res?.code == 1) {
              //           this.$message({ message: "支付成功" });
              //           this.hideWaitPayDialog();
              //           this.getOrderDetail();

              //           this.gaTrack4Purchase();
              //         } else {
              //           console.warn(res);
              //         }
              //       } catch (err) {
              //         console.warn(err, evt);
              //         captureManualError(err)
              //       } finally {
              //         ws?.close();
              //         oderPayTimer && clearInterval(oderPayTimer);
              //       }
              //     } else {
              //       console.warn(evt);
              //       ws?.close();
              //       oderPayTimer && clearInterval(oderPayTimer);
              //     }
              //   }
              // );
              this.showWaitPayDialog();
            } else {
              this.payStatus = "unknown";
              window.location.href = res?.data?.url;
            }
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err)
        });
    },
    // 刷新支付二维码
    refreshPayCode() {
      this.orderPay();
    },
    showWaitPayDialog() {
      this.payStatus = "wait";
    },
    hideWaitPayDialog() {
      this.wsInstance?.close();
      this.oderPayTimer && clearInterval(this.oderPayTimer);
      this.payStatus = "";
    },
    closePayUnknown() {
      this.payStatus = "";
      this.getOrderDetail();
    },
    // 查询支付状态
    checkOrderStatus(id) {
      const intervalId = setInterval(() => {
        if (this.payStatus === 'success') {
          clearInterval(intervalId)
          return
        }
        api[types.ORDER_STATUS]({ id }).then((res) => {
          if (res.code === 1 && res.data.status === 1) {
            this.$message({ message: "支付成功" });
            this.payStatus = "success";
            this.hideWaitPayDialog();
            this.getOrderDetail();
            this.gaTrack4Purchase();
            intervalId && clearInterval(intervalId);
          }
        }).catch((err) => {
          captureManualError(err);
          console.error('查询支付状态失败:', err);
        });

      }, 3000);
      this.orderStatusTimer = intervalId;
    },
    clearOrderPayTimer() {
      this.orderStatusTimer && clearInterval(this.orderStatusTimer);
    },
    // GA埋点
    gaTrack4Purchase() {
      const params = {
        send_to: process.env?.VUE_APP_GA4,
        currency: "CNY",
        transaction_id: this.orderInfo.id || this.$route.query.id,
        shipping: Number(this.orderInfo.shipping),
        value: Number(this.orderInfo.amount),
        items: this.orderInfo.goods.map((o) => ({
          item_id: `${o.goodsId}-${o.color.id}`,
          item_name: o.name,
          price: Number(o.price),
          quantity: Number(o.quantity),
          item_brand: "Onitsuka Tiger",
          item_variant: o.color.name,
          currency: "CNY",
        })),
      };
      if (window.gtag) {
        window.gtag("event", "purchase", params);
      }
    },
    // 订单取消
    toCancel() {
      let orderId = this.orderInfo.id || this.$route.query.id;
      this.$confirm("确定要取消订单吗？")
        .then(() => {
          api[types.CANCEL_ORDER]({ orderId })
            .then((res) => {
              if (res?.code == 1) {
                this.getOrderDetail();
              } else {
                console.warn(res);
              }
            })
            .catch((err) => {
              console.warn(err);
              captureManualError(err)
            });
        })
        .catch((error) => { captureManualError(error) });
    },
    // 退货信息保存
    saveRefund() {
      this.$refs.refundInfoForm.validate((valid) => {
        if (valid) {
          let newArgs = Object.assign(
            {
              id: this.orderInfo.id || this.$route.query.id,
            },
            this.refundInfoForm
          );
          api[types.SAVE_REFUND_INFO](newArgs)
            .then((res) => {
              if (res?.code == 1) {
                this.getOrderDetail();
              } else {
                console.warn(res);
              }
            })
            .catch((err) => {
              console.warn(err);
              captureManualError(err)
            });
        }
      });
    },
    goBack() {
      this.$router.push({ path: "/myaccount/orders" });
    },
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id) {
        return
      }
      if(Number(item.skc_status) === 0){
        //skc下架
        return
      }
      this.$router.push({ path: `/detail/${item.goodsId}-${item.color.id}` });
    },
  },
  filters: {
    namify(str) {
      return (
        {
          SF: "顺丰快递",
          JD: "京东快递",
          EMS: "邮政EMS",
          STO: "申通快递",
          YTO: "圆通速递",
          ZTO: "中通速递",
          HTKY: "汇通快运",
          YUNDA: "韵达快递",
          DBL: "德邦快递",
          fedex: "联邦快递",
          TTKDEX: "天天快递",
          BAISHI: "百世快递",
          CCES: "CCES快递",
          ZJS: "宅急送",
          OTHER: "E邮宝",
          PINJUN: "品骏物流",
          KYE: "跨越速运",
          yunda_jitx: "韵达JITX",
          zto_jitx: "中通JITX",
          QTKD: "其他快递",
        }[str] || str
      );
    },
  },
  beforeDestroy: function () {
    this.clearOrderPayTimer()
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  text-align: left;

  .page-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;

    .icon-back {
      color: #bcbcbc;
      line-height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }

    .page-title {
      font-size: 13px;
      color: #333333;
      line-height: 40px;
      text-align: center;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
  }

  .order-status {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background: #fbfbfb;

    .status-left {
      display: flex;
      align-items: center;

      .iconfont {
        font-size: 35px;
        color: #7f0019;
        margin-right: 20px;
      }

      .status-title {
        font-size: 16px;
        color: #7f0019;
      }

      .status-txt {
        color: #666;
        font-size: 14px;

        span {
          color: #8b0013;
        }
      }
    }

    .pay-btn {
      display: flex;
    }

    .logistics-btn,
    .cancel-btn {
      display: none;
      cursor: pointer;
    }
  }

  .order-item,
  .order-list {
    color: #666;
    font-size: 14px;
    padding: 30px 0;
    box-sizing: border-box;

    .order-title {
      font-size: 13px;
      color: #333;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .txt {
      font-size: 12px;
      line-height: 24px;

      a {
        text-decoration: underline;
      }
    }

    .order-content {
      border: none;

      .content-title {
        display: none;
      }

      .content {
        max-height: 330px;
        overflow-y: auto;

        .goods-items {
          &+.goods-items {
            margin-top: 24px;
          }

          .markdown-tip {
            display: flex;
            align-items: center;
            color: #212322;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            margin-top: 8px;

            .iconfont-ot-website {
              margin-right: 2px;
            }

            &.is-desktop {
              display: none;
            }

            &.is-mobile {
              display: block;
            }
          }
        }

        .goods-items-content {
          display: flex;
          box-sizing: border-box;
          padding: 0;

          .item-img {
            width: 86px;
            height: 86px;
            border-radius: 1px;
            border: 1px solid #dfdfdf;
            margin-right: 8px;
            flex-shrink: 0;
            box-sizing: border-box;
            padding: 2px;

            .goods-pic {
              width: 78px;
              height: auto;
            }
          }

          .goods-right {
            display: flex;
            flex-direction: column;
          }

          .goods-info {
            display: flex;
            flex-direction: column;
            width: 100%;

            .goods-size {
              display: flex;
              color: #999999;
              font-size: 12px;
            }

            .goods-name {
              font-size: 14px;
              color: #333;
            }
          }

          .goods-others {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 10px;
            font-size: 12px;
            line-height: 18px;
            color: #000;

            .item-original_price {
              font-weight: 400;
              color: #999;
              text-decoration: line-through;
            }
          }
        }
      }
    }
  }

  .order-item {
    border-bottom: 1px solid #d7d8d8;
  }

  .order-others {
    padding-bottom: 30px;

    .total {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &+.total {
        margin-top: 8px;
      }
    }

    .tit {
      font-size: 14px;
      line-height: 20px;
      color: #000;
      font-weight: 400;
    }

    .num {
      font-family: Matter;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #999999;
    }
  }

  .logistics-bottom {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .logistics-btn,
  .cancel-btn {
    width: 157px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    justify-content: flex-end;
    cursor: pointer;
  }

  .logistics-btn {
    background: #7f0019;
    color: #fff;
  }

  .cancel-btn {
    background: #fff;
    color: #000;
    border: 1px solid #e7e7e7;
    margin-left: 20px;
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 1010;
      background: url(../../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;

      .dialog-header {
        position: relative;
        text-align: left;
      }

      .dialog-body {
        display: flex;
      }
    }

    &.wait-pay {
      .dialog-container {
        width: 470px;
        height: 570px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          align-items: center;

          .pay-method {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 45px;

            .iconfont {
              font-size: 40px;

              &.ali-pay {
                color: rgb(0, 159, 233);
              }

              &.wx-pay {
                color: rgb(79, 163, 42);
              }
            }

            .pay-name {
              font-size: 20px;
              margin-left: 10px;
            }
          }

          .pay-amount {
            font-size: 14px;
            color: #666666;
            margin-top: 20px;

            .pay-value {
              font-size: 25px;
              color: #8b0013;
            }
          }

          .pay-hits {
            height: 40px;
            margin-top: 18px;

            .pay-countdown,
            .pay-msg {
              font-size: 14px;
              line-height: 20px;
              color: #666666;
              text-align: center;

              .countdown {
                color: #8b0013;
              }
            }
          }

          .pay-code {
            margin-top: 10px;
            position: relative;

            img {
              width: 190px;
              height: 190px;
            }

            .code-mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              span {
                color: #fff;
              }
            }
          }

          .pay-method-tips {
            height: 40px;
            margin-top: 10px;

            .text {
              font-size: 14px;
              line-height: 20px;
              color: #333333;
              text-align: center;
            }
          }
        }
      }
    }

    &.pay-unknown {
      .dialog-container {
        width: 472px;
        height: 310px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          .dialog-subtitle {
            font-size: 16px;
            color: #333333;
            font-weight: 700;
            margin-top: 40px;
          }

          .txt-line {
            font-size: 14px;
            color: #666666;

            &.mt20 {
              margin-top: 20px;
            }
          }

          .btn-group {
            margin-top: 28px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 20px;
                color: #666666;
                background: #ffffff;
                border: 1px solid #e7e7e7;
              }
            }
          }
        }
      }
    }
  }

  // 物流弹框
  .modal {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    top: 0;
    left: 0;

    .logistics {
      position: absolute;
      min-width: 90%;
      min-height: 520px;
      background: #fff;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      padding: 30px 40px;
      box-sizing: border-box;
      text-align: center;

      .iconfont {
        position: absolute;
        right: 40px;
        top: 30px;
        font-size: 25px;
      }

      .title {
        font-size: 20px;
        color: #333;
        text-align: left;
        margin-bottom: 30px;
      }

      .txt {
        color: #999;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: left;

        span {
          color: #333;
        }
      }

      .detail {
        max-height: 240px;
        overflow-y: auto;
        border-top: 1px solid #d7d8d8;
        border-bottom: 1px solid #d7d8d8;
        padding: 10px 0;
        box-sizing: border-box;
        margin-bottom: 40px;

        .row {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          font-size: 14px;
          text-align: left;

          .time {
            color: #999;
            flex-shrink: 0;
            margin-right: 40px;
          }

          .desc {
            color: #333;
            margin-bottom: 20px;
          }

          .current {
            color: #7f0019;
          }
        }
      }

      .sure-btn {
        width: 80%;
        height: 30px;
        color: #fff;
        font-size: 14px;
        background: #7f0019;
      }
    }
  }
}

@media only screen and (min-width: 1025px) {
  .order-detail {
    .page-header {
      display: none;
    }

    .order-status {
      .status-left {
        .status-title {
          font-size: 20px;
        }
      }

      .logistics-btn {
        display: block;
      }

      .cancel-btn {
        display: block;
      }
    }

    .order-item,
    .order-list {
      color: #666;
      font-size: 14px;
      padding: 30px 0;
      box-sizing: border-box;

      .order-title {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .txt {
        font-size: 14px;
        line-height: 24px;
      }

      & ::v-deep .el-form {
        .el-form-item {
          .el-form-item__content {

            .el-input,
            .el-select {
              width: 200px;
            }
          }
        }
      }

      .save-refund {
        margin-left: 100px;
      }

      .order-content {
        border: 1px solid #d2d2d2;

        .content-title {
          height: 40px;
          color: #333;
          font-size: 14px;
          line-height: 40px;
          border-bottom: 1px solid #d2d2d2;
          margin-bottom: 20px;
          padding-left: 30px;
          display: block;
        }

        .content {
          max-height: 330px;
          overflow-y: auto;

          .goods-items {
            .markdown-tip {
              display: flex;
              align-items: center;
              color: #212322;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 6px;

              .iconfont-ot-website {
                margin-right: 2px;
              }

              &.is-desktop {
                display: block;
              }

              &.is-mobile {
                display: none;
              }
            }
          }

          .goods-items-content {
            display: flex;
            box-sizing: border-box;
            margin-bottom: 20px;
            padding: 0 30px;

            .item-img {
              width: 70px;
              height: 70px;
              border-radius: 1px;
              border: 1px solid #dfdfdf;
              margin-right: 20px;
              flex-shrink: 0;
              box-sizing: border-box;
              padding: 2px;

              .goods-pic {
                width: 64px;
                height: 64px;
              }
            }

            .goods-right {
              display: flex;
              flex-direction: row;
              flex-grow: 1;

              .goods-info {
                display: flex;
                flex-direction: column;
                width: 60%;

                .goods-size {
                  display: flex;
                  color: #999999;
                  font-size: 14px;
                }

                .goods-name {
                  font-size: 14px;
                  color: #333;
                }
              }

              .goods-others {
                width: 40%;
                align-self: flex-start;
                margin-top: 0;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }

    .order-others {
      .total {
        .num {
          font-size: 18px;
          line-height: 28px;
        }
      }
    }

    .logistics-bottom {
      display: none;
    }

    // 物流弹框
    .modal {
      .logistics {
        min-width: 726px;

        .detail {
          .row {
            flex-direction: row;
          }
        }

        .sure-btn {
          width: 157px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .order-detail {
    .bread-crumbs {
      display: none;
    }

    .page-header {
      display: block;
    }

    .dialog.pay-unknown {
      .dialog-container {
        width: 285px;
        height: 225px;

        .dialog-body {
          .dialog-subtitle {
            margin-top: 8px;
          }

          .txt-line {
            font-size: 12px;
          }

          .btn-group {
            margin-top: 20px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width:480px) {
  .goods-items {
    .markdown-tip {
      display: flex;
      align-items: center;
      color: #212322;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 6px;

      .iconfont-ot-website {
        margin-right: 2px;
      }

      &.is-mobile {
        display: none;
      }
    }
  }
}
</style>